import FormControl from "../../../MUI_components/FormControl/fomikFormControl";
import { Form, Formik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import reportsService from "../../../../Service/Reports/reports.service";
import ReactToPrint from "react-to-print";
import { pageStyle } from "../../../Print/printPagesStyles";
import BasicTable from "../../../MUI_components/Table/basicTable";
import ReportPrintTable from "../../reportPrintTable";
import { Button, Paper } from "@mui/material";
import { useDispatch } from "react-redux";
import { openSnackbar } from "../../../../Redux/Actions/snackbarActions";
import * as yup from "yup";
// import Reports from "Components/Print/a4-report-print";

import { COLUMNS_NAME } from "Components/Constants/ColumnsNames";
import { DownloadTableExcel } from "react-export-table-to-excel";
import { PAYMENT_TYPE_CODE } from "Components/Constants/PaymentTypeCode";
import { currency } from "Components/MUI_components/currencyFormatterTag";
import Reports from "../../../../Components/Reports/reports";
import Title from "Components/Card/title";
import { LOCAL_STORAGE } from "Components/Constants/LocalStorage";

export default function Dailyresults() {

  const dispatch = useDispatch();
  const today = new Date().toISOString().split("T")[0];
  const [results, setResults] = React.useState({
    rows: [],
    date: null,
    loading: false,
  });
  const tableRef = useRef(null);
  const [type, setType] = useState("");

  const HeadCells = [
    
    {
      key: (val) => {
        return `${val["grn"]["code"]} 
        (${val["paymentVoucher"]["code"]}-${val["paymentVoucher"]["totalAmount"]})` 
      },
      align: "left",
      label: COLUMNS_NAME.GRN_NUMBER +"("+ COLUMNS_NAME.VOUCHER_NO+")",
    },
    {
      key: (val) => {
        return val["paymentVoucher"]["supplier"]["name"]
      },
      align: "right",
      label:COLUMNS_NAME.SUPPLIER,
    },
    {
 
      key: (val) => {
        return currency(val["grnTotal"]) 
      } ,
      align: "right",
      label: COLUMNS_NAME.GRN_TOTAL,
    },
    {

      key: (val) => {
        return currency(val["outstanding"]) 
      },
      align: "right",
      label: COLUMNS_NAME.OUTSTANDING,
    },
    {
      key: (val) => {
        return currency((val.paymentVoucher.supplierModeOfPayments.filter((mode) => mode.paymentTypeCode == PAYMENT_TYPE_CODE.CASH_PAYMENT)?.map((elem) => elem.amount)?.reduce((sum, i) => sum + i, 0))) 
      },
      align: "right",
      label: 'Cash',
    },
    {
      key: (val) => {
        return currency((val.paymentVoucher.supplierModeOfPayments.filter(
          mode => mode.paymentTypeCode == PAYMENT_TYPE_CODE.CHEQUE_PAYMENT
        ).map(elem => Number(elem.amount))?.reduce((sum, i) => sum + i, 0)))
      },
      align: "right",
      label: 'Cheque',
    },

    {
      key: (val) => {
        return currency((val.paymentVoucher.supplierModeOfPayments.filter(
          (mode) => mode.paymentTypeCode == PAYMENT_TYPE_CODE.BANK_DEPOSIT
        )?.map((elem) => elem.amount)?.reduce((sum, i) => sum + i, 0)))
      },
      align: "right",
      label: 'Bank Deposit',
    },
   {
      key: (val) => {
        return currency((val.paymentVoucher.supplierModeOfPayments.filter(
          (mode) => mode.paymentTypeCode == PAYMENT_TYPE_CODE.CARD_PAYMENT
        )?.map((elem) => elem.amount)?.reduce((sum, i) => sum + i, 0)))
      },
      align: "right",
      label: 'Card Payment',
    },
    {
      key: (val) => {
          return currency((val.paymentVoucher.supplierModeOfPayments.filter(
            (mode) => mode.paymentTypeCode == PAYMENT_TYPE_CODE.OVER_PAYMENT
          )?.map((elem) => elem.amount)?.reduce((sum, i) => sum + i, 0)))
        },
        align: "right",
        label: 'Over Payment',
      },
      {
        key: (val) => {
            return currency((val.paymentVoucher.supplierModeOfPayments.filter(
              (mode) => mode.paymentTypeCode == PAYMENT_TYPE_CODE.RETURN_AMOUNT
            )?.map((elem) => elem.amount)?.reduce((sum, i) => sum + i, 0)))
          },
          align: "right",
          label: 'Return Amount',
        },
        {
          key: (val) => {
              return currency((val.paymentVoucher.supplierModeOfPayments.filter(
                (mode) => mode.paymentTypeCode == PAYMENT_TYPE_CODE.ONLINE_TRANSFER
              )?.map((elem) => elem.amount)?.reduce((sum, i) => sum + i, 0)))
            },
            align: "right",
            label:COLUMNS_NAME.ONLINE_TRANSFER,
          },
  


 ];
  const componentRef = React.useRef();

  const handleSubmit = async (values) => {
    setResults({
      ...results,
      loading: true,
    });
    try {
      const res = await reportsService.PaymentVoucherByPaymentType(values.date);
      setResults({
        loading: false,
        rows: res.grnVoucherDetails,
        date: values.date,
      });
    } catch (e) {
      dispatch(openSnackbar(true, "error", e));
    }
  };


  const [paymentTypeTotals, setPaymentTypeTotals] = useState({
    Cash: 0,
    Cheque: 0,
    BankDeposit: 0,
    Card: 0,
    OverPayment: 0,
    ReturnAmount: 0,
    OnlinePayment:0,
  });
  
  const calculatePaymentTypeTotals = () => {
    const totals = {
      Cash: 0,
      Cheque: 0,
      BankDeposit: 0,
      Card: 0,
      OverPayment: 0,
      ReturnAmount: 0,
      OnlinePayment:0,
    };

    results.rows.forEach((row)=>{
      row.paymentVoucher.supplierModeOfPayments.forEach((elem)=>{
          switch(elem.paymentTypeCode){
            case PAYMENT_TYPE_CODE.CASH_PAYMENT:
              totals.Cash += parseFloat(elem.amount);
              break;
            case PAYMENT_TYPE_CODE.CHEQUE_PAYMENT:
              totals.Cheque += parseFloat(elem.amount);
              break;
            case PAYMENT_TYPE_CODE.BANK_DEPOSIT:
              totals.BankDeposit += parseFloat(elem.amount);
              break;
            case PAYMENT_TYPE_CODE.CARD_PAYMENT:
              totals.Card += parseFloat(elem.amount);
              break;
            case PAYMENT_TYPE_CODE.OVER_PAYMENT:
              totals.OverPayment += parseFloat(elem.amount);
              break;
            case PAYMENT_TYPE_CODE.RETURN_AMOUNT:
              totals.ReturnAmount += parseFloat(elem.amount);
              break;
              case PAYMENT_TYPE_CODE.ONLINE_TRANSFER:
                totals.OnlinePayment += parseFloat(elem.amount);
                break;
            // Add other cases for additional payment types if needed
            default:
              break;
          }
        });
      });

    setPaymentTypeTotals(totals);
  };
// console.log(paymentTypeTotals.Cash);
   // Call the calculatePaymentTypeTotals function whenever results.rows changes
   useEffect(() => {
    calculatePaymentTypeTotals();
  }, [results.rows]);




  const billTotal = results.rows
  .map((props) => parseFloat(props["grnTotal"]))
  .reduce((sum, i) => sum + i, 0);

  const settledAmountTotal = results.rows
  .map((props) => parseFloat(props["outstanding"]))
  .reduce((sum, i) => sum + i, 0);

  // const PaymentType = () => {
  //   results.rows.map((row) => (
  //     row.paymentVoucher.modeOfPayments.map((type) => (
  //       type.paymentTypeCode
  //     ))))
  // }



  // const billTotal = results.rows
  //   .map((props) => parseFloat(props["total"]))
  //   .reduce((sum, i) => sum + i, 0);

  const Validation = yup.object({
    date: yup.date().required("Date is Required").nullable(),
  });

  return (
    <div style={{ display: 'flex', width: '100%' }}>
    <div >
      <Reports />
    </div>
    <div style={{width: '100%'}}>
      <Formik
        initialValues={{
          date: today,
        }}
        validationSchema={Validation}
        onSubmit={handleSubmit}
      >
        {() => {
          return (
            <Form>
              <Title>Payment Voucher By payment Type</Title>
              <div className="flex mt mb">
                <div className="col-4">
                  <FormControl
                    control="input"
                    type="date"
                    name="date"
                    size="small"
                    label="Daily Receipt"
                    inputProps={{
                      max: today,
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </div>
                <div className="col-6">
                  <Button variant="contained" type="submit" color="primary">
                    Find
                  </Button>
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
      <Paper>
        <div className="flex-end">
          <ReactToPrint
            trigger={() => (
              <Button
                style={{ margin: 5 }}
                disabled={!results.rows.length}
                variant="contained"
              >
                Print
              </Button>
            )}
            content={() => componentRef.current}
            pageStyle={pageStyle.a4}
          />
          <DownloadTableExcel
            filename="daily Payment Voucher"
            currentTableRef={tableRef.current}
          >
            <Button
              style={{ margin: 5 }}
              disabled={!results.rows.length}
              variant="contained"
            >
              Export to Excel </Button>
          </DownloadTableExcel>
        </div>
        <div style={{ display: "none" }}>
          
            <Reports >
            <div ref={componentRef}>
              <ReportPrintTable
               title={`Payment Voucher By Payment Type: ${results.date} Location : ${JSON.parse(localStorage.getItem(LOCAL_STORAGE.BIZX_LOCATION)).name}`}
                headCells={HeadCells}
                rows={results.rows}
              >
              <tr>
            <th colSpan={2}></th>
            <th style={{ borderTop: "1.5px solid #000" }} align="right">
              Total:
            </th>
            <th style={{ borderTop: "1.5px solid #000" }} align="right">
              {currency((billTotal.toFixed(2)))}
            </th>
            {/* <th style={{ borderTop: "1.5px solid #000" }} align="right">
              {(settledAmountTotal.toFixed(2))}
            </th>
            <th style={{ borderTop: "1.5px solid #000" }} align="right">
              {(paymentTypeTotals.Cash.toFixed(2))}
            </th>
            <th style={{ borderTop: "1.5px solid #000" }} align="right">
              {(paymentTypeTotals.Cheque.toFixed(2))}
            </th>
            <th style={{ borderTop: "1.5px solid #000" }} align="right">
              {(paymentTypeTotals.BankDeposit.toFixed(2))}
            </th>
            <th style={{ borderTop: "1.5px solid #000" }} align="right">
              {(paymentTypeTotals.Card.toFixed(2))}
            </th>
            <th style={{ borderTop: "1.5px solid #000" }} align="right">
              {(paymentTypeTotals.OverPayment.toFixed(2))}
            </th>
            <th style={{ borderTop: "1.5px solid #000" }} align="right">
              {(paymentTypeTotals.ReturnAmount.toFixed(2))}
            </th>
            <th style={{ borderTop: "1.5px solid #000" }} align="right">
              {(paymentTypeTotals.OnlinePayment.toFixed(2))}
            </th> */}
            </tr>
            </ReportPrintTable>
              </div>
            </Reports>
          
        </div>

        <BasicTable
          headCells={HeadCells}
          rows={results.rows}
          isLoaded={results.loading}
          tableRef={tableRef}
        />
      </Paper>
    </div>    
    </div>    
  );
}